import { useQuery } from "@tanstack/react-query";
import { WorldMap } from "@/components/map/WorldMap";
import { api } from "@/lib/api";
import { Overlap } from "./Overlap";

const noop = () => {};

const MapCard = ({ title, data, geo, testId, accent }) => (
  <div className="rounded-2xl border border-white/10 bg-[#0D131F] overflow-hidden" data-testid={testId}>
    <div className="flex items-center justify-between px-4 py-3 border-b border-white/5">
      <p className="font-display font-semibold" style={{ color: accent }}>{title}</p>
      <p className="font-mono text-[11px] text-slate-500">{data.visited.length} countries · {data.visited.reduce((s, v) => s + v.cities.length, 0)} cities</p>
    </div>
    <div className="h-[320px] sm:h-[380px] relative">
      {geo ? <WorldMap geo={geo} visited={data.visited} wishlist={data.wishlist} selected={null} onSelect={noop} onCity={noop} focus={null} compact /> : null}
    </div>
  </div>
);

export const FriendCompare = ({ friend, me, geo }) => {
  const { data, error } = useQuery({ queryKey: ["friend", friend.friend_id], queryFn: () => api.friend(friend.friend_id), retry: false });
  if (error)
    return <p className="mt-8 text-sm text-amber-300" data-testid="friend-error">{error?.response?.data?.detail || "Could not load this friend's map."}</p>;
  if (!data) return <p className="mt-8 font-mono text-xs text-slate-500" data-testid="friend-loading">Loading {friend.name}'s map…</p>;
  const first = friend.name.split(" ")[0];
  return (
    <div className="mt-8 space-y-6 animate-rise">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <MapCard title="You" data={me} geo={geo} testId="compare-map-me" accent="#34D399" />
        <MapCard title={first} data={data} geo={geo} testId="compare-map-friend" accent="#7DD3FC" />
      </div>
      <Overlap me={me} friend={data} name={first} />
    </div>
  );
};
